/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { CommentContainer_settings$ref } from "./CommentContainer_settings.graphql";
import { ReactionButtonContainer_settings$ref } from "./ReactionButtonContainer_settings.graphql";
import { UserTagsContainer_settings$ref } from "./UserTagsContainer_settings.graphql";
declare const _AnsweredCommentContainer_settings$ref: unique symbol;
export type AnsweredCommentContainer_settings$ref = typeof _AnsweredCommentContainer_settings$ref;
export type AnsweredCommentContainer_settings = {
    readonly " $fragmentRefs": ReactionButtonContainer_settings$ref & UserTagsContainer_settings$ref & CommentContainer_settings$ref;
    readonly " $refType": AnsweredCommentContainer_settings$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "AnsweredCommentContainer_settings",
    "type": "Settings",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ReactionButtonContainer_settings",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "UserTagsContainer_settings",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "CommentContainer_settings",
            "args": null
        }
    ]
} as any);
(node as any).hash = '0d3217329648518b300fb0bc3cf37fce';
export default node;
